import { animate, cubicBezier } from 'popmotion';
import { useEffect, useRef } from 'react';
import React from 'react';

function usePrevious(value: number): number | undefined {
  const ref = useRef<number>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

interface Props {
  value: number;
}

const CountUp: React.FC<Props> = ({ value = 0 }) => {
  // Typing the ref for the HTMLSpanElement
  const ref = useRef<HTMLSpanElement | null>(null);
  const previousValue = usePrevious(value);

  useEffect(() => {
    if (ref.current) {
      animate({
        from: previousValue || 0,
        to: value,
        duration: 875,
        ease: cubicBezier(1, 0, 0, 1),
        onUpdate: (latestValue) => {
          if (ref.current) {
            ref.current.innerText = Math.round(latestValue).toString();
          }
        },
      });
    }
  }, [value, previousValue]); // Include `previousValue` as a dependency

  return <span ref={ref}>{value}</span>;
};

export default CountUp;
